import * as React from "react";
import * as cn from "classnames";

export interface SvgBackgroundProps {
    svg: string;
    className?: string;
    title?: string;
}

export function SvgBackground(props: SvgBackgroundProps) {
    return (
        <span
            className={cn(props.className)}
            style={{
                background: `${props.svg} center center no-repeat`,
                backgroundSize: "contain",
                MozBackgroundSize: "contain",
                WebkitBackgroundSize: "contain"
            }}
            title={props.title}
        />
    );
}
